module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StepId == 1),
      expression: "StepId==1"
    }],
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [_c('el-form-item', {
    attrs: {
      "label": "归属方:"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentStyle
    },
    model: {
      value: (_vm.form.AgentStyle),
      callback: function($$v) {
        _vm.$set(_vm.form, "AgentStyle", $$v)
      },
      expression: "form.AgentStyle"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("代理商")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("业务员")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": '所属' + _vm.labelName + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择" + _vm._s(_vm.labelName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseSchool
    }
  }, [_vm._v("选择幼儿园")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐:"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "change": _vm.changePackage
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, _vm._l((_vm.orderPackages), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.label
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课班级数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": _vm.minNum
    },
    on: {
      "change": _vm.changeNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.openClassList), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '开课班级' + (index + 1)
      }
    }, [_c('el-select', {
      staticClass: "formlength",
      attrs: {
        "placeholder": "-请选择-"
      },
      on: {
        "change": function($event) {
          _vm.changeVal(index)
        }
      },
      model: {
        value: (item.ClassId),
        callback: function($$v) {
          _vm.$set(item, "ClassId", $$v)
        },
        expression: "item.ClassId"
      }
    }, _vm._l((item.ClassLists), function(option) {
      return _c('el-option', {
        key: option.ClassId,
        attrs: {
          "value": option.ClassId,
          "label": option.ClassName
        }
      })
    })), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0 && !_vm.showData.isReadOnly),
        expression: "index==0&&!showData.isReadOnly"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": _vm.addClass
      }
    }, [_vm._v("创建班级")])], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套课程"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.courses,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套物料:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.materiel,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showData.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowStockArea),
      expression: "isShowStockArea"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否使用经销商库存发货:",
      "label-width": "170px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeIsUseAgentStock
    },
    model: {
      value: (_vm.form.IsUseAgentStock),
      callback: function($$v) {
        _vm.$set(_vm.form, "IsUseAgentStock", $$v)
      },
      expression: "form.IsUseAgentStock"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.IsUseAgentStock == 1),
      expression: "form.IsUseAgentStock==1"
    }],
    attrs: {
      "label": "请选择使用库存代理商",
      "label-width": "160px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "change": _vm.changeAgentId
    },
    model: {
      value: (_vm.form.ChooseAgentId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ChooseAgentId", $$v)
      },
      expression: "form.ChooseAgentId"
    }
  }, _vm._l((_vm.AgentLists), function(option) {
    return _c('el-option', {
      key: option.Id,
      attrs: {
        "value": option.Id,
        "label": option.Customer
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.IsUseAgentStock == 1),
      expression: "form.IsUseAgentStock==1"
    }],
    attrs: {
      "label": "使用经销库存发货数:",
      "label-width": "160px"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": _vm.stockNumMax
    },
    model: {
      value: (_vm.stockNum),
      callback: function($$v) {
        _vm.stockNum = $$v
      },
      expression: "stockNum"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（当前可使用库存数量：" + _vm._s(_vm.stockTotalNum) + "）")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")])]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly && _vm.ConsigneeList !== ''),
      expression: "!showData.isReadOnly&&ConsigneeList!==''"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("修改地址")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("物流")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("寄付（送货）")])])], 1), _vm._v(" "), _vm._l((_vm.payList), function(item, index) {
    return (_vm.price > 0) ? _c('payTypeInfo', {
      ref: 'payInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": (index + 1),
        "value": item,
        "hasDelFn": _vm.isDelShow[index]
      },
      on: {
        "delPayfn": _vm.delPayFn
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly && (this.price > 0)),
      expression: "!showData.isReadOnly&&(this.price>0)"
    }]
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("新增支付方式")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.OrderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderRemark", $$v)
      },
      expression: "form.OrderRemark"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]), _vm._v("(保存订单信息,进入园所信息完善页面)\n                ")], 1)], 1)], 2), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StepId == 2),
      expression: "StepId==2"
    }],
    attrs: {
      "model": _vm.netWorkData,
      "label-width": "170px"
    }
  }, [_c('h4', [_vm._v("网络情况")]), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所网络运营商："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.netWorkData.NetworkOperator),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "NetworkOperator", $$v)
      },
      expression: "netWorkData.NetworkOperator"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("移动")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("电信")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("联通")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 8
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所网络情况："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.netWorkData.NetworkType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "NetworkType", $$v)
      },
      expression: "netWorkData.NetworkType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("有线")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("无线")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowD),
      expression: "isShowD"
    }],
    attrs: {
      "label": "电视到宽带口距离多远："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.netWorkData.Distance),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "Distance", $$v)
      },
      expression: "netWorkData.Distance"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("10米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("30米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("50米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 8
    }
  }, [_vm._v("100米以上")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否需要上门服务："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.netWorkData.Engineer),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "Engineer", $$v)
      },
      expression: "netWorkData.Engineer"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("需要工程师上门")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("不需要,自己解决网络")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showData.IsEdit !== 0) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所照片："
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "display": "block"
    }
  }, [_vm._v("(需上传带Logo及园所名称的照片)")]), _vm._v(" "), _c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.SchoolPics), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showData.IsEdit == 0),
        expression: "showData.IsEdit==0"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.netWorkData.SchoolPics, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.IsEdit == 0),
      expression: "showData.IsEdit==0"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.SchoolPicsCtnId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.SchoolPicsBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "签约方证明："
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "display": "block"
    }
  }, [_vm._v("(三证任选其一)")]), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.netWorkData.ProveType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "ProveType", $$v)
      },
      expression: "netWorkData.ProveType"
    }
  }, [_vm._v("办园许可证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.netWorkData.ProveType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "ProveType", $$v)
      },
      expression: "netWorkData.ProveType"
    }
  }, [_vm._v("民办许可证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.netWorkData.ProveType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "ProveType", $$v)
      },
      expression: "netWorkData.ProveType"
    }
  }, [_vm._v("园长身份证 ")]), _vm._v(" "), (_vm.showData.IsEdit !== 0) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.netWorkData.ProveType == 2),
      expression: "netWorkData.ProveType==2"
    }],
    staticStyle: {
      "color": "red",
      "display": "block"
    }
  }, [_vm._v("(身份证最少上传两张，照片面和国徽面)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.ProvePics), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showData.IsEdit == 0),
        expression: "showData.IsEdit==0"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.netWorkData.ProvePics, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.IsEdit == 0),
      expression: "showData.IsEdit==0"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.LicencePicsCtnId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.LicencePicsBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.ContractPices), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showData.IsEdit == 0),
        expression: "showData.IsEdit==0"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.netWorkData.ContractPices, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.IsEdit == 0),
      expression: "showData.IsEdit==0"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.EquipPicsCtnId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.EquipPicsBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开课申请表："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.CooperationPics), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showData.IsEdit !== 2),
        expression: "showData.IsEdit!==2"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.netWorkData.CooperationPics, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": _vm.CooperationPicsCtnId
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.IsEdit !== 2),
      expression: "showData.IsEdit!==2"
    }],
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.CooperationPicsBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.backFn
    }
  }, [_vm._v("返回上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交订单")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('schoolList', {
    ref: "refschoolList",
    on: {
      "getSchoolItem": _vm.getSchoolItem
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getSchoolConsigneeList": _vm.getSchoolConsigneeList
    }
  }), _vm._v(" "), _c('optOpenClassDialog', {
    ref: "refoptOpenClassDialog",
    on: {
      "shcoolList": _vm.getSchoolName
    }
  }), _vm._v(" "), _c('addClass', {
    ref: "refAddClass",
    on: {
      "getClassList": _vm.getClassList
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "showClose": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "60px"
    }
  }, [_vm._v("该幼儿园名下暂无班级！")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary ",
      "size": "samll "
    },
    on: {
      "click": _vm.other
    }
  }, [_vm._v("选择其他幼儿园")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary ",
      "size": "samll "
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("创建班级")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f465b1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/addD55Order/index.vue
// module id = 1435
// module chunks = 1